import { getShellBaseUrl } from '@/services/core';
import { normalizeUrl } from '@/utils/url';

export type ShellManifest = {
  version: string;
  maintenance?: {
    active: boolean;
    reason: string;
  };
};

export function getRuntimeManifest(): Promise<ShellManifest> {
  const cacheBust = new Date().getTime().toString();
  return fetch(`${normalizeUrl(getShellBaseUrl())}manifest.json?_=${cacheBust}`).then((response) =>
    response.json(),
  );
}

export default {
  version: __SHELL_VERSION__,
  isUnderMaintenance: __SHELL_IS_MAINTENANCE__ === true,
  underMaintenanceReason: __SHELL_MAINTENANCE_REASON__ ?? '',
};
